import moment from 'moment-timezone';
import React from 'react';

const NotificationLogsTable = ({ logs, onView }) => {
    const renderTableHeader = React.useCallback(() => {
        return (
            <tr>
                <th className="col-2">
                    <span>Date</span>
                </th>
                <th className="col-1">
                    Time
                </th>
                <th className="col-3">
                    Recipient
                </th>
                <th className="col-4">
                    Subject
                </th>
                <th className="col-1 text-center">
                    Status
                </th>
                <th className="col-1 text-center">
                    Action
                </th>
            </tr>
        );
    }, []);

    const renderTableContent = React.useCallback((item) => {
        return (
            <NotificationLogItem item={item} key={item?.id} onView={onView} />
        );
    }, [onView]);

    return (
        <div className='table_responsive'>
            <table className="table">
                <thead className="text-primary">
                    {renderTableHeader()}
                </thead>
                <tbody>
                    {
                        logs && logs.length > 0 ? (
                            logs.map(item => renderTableContent(item))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center text-muted p-4">
                                    No notifications logged.
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    );
};

const NotificationLogItem = ({ item, onView }) => {
    const localTime = item?.created_at ? moment.utc(item.created_at).tz("America/Los_Angeles") : null;
    const formattedDate = localTime ? localTime.format("MMM D, YYYY") : "";
    const formattedTime = localTime ? localTime.format("hh:mm A") : "";

    return (
        <tr>
            <td className='col-2'>
                {formattedDate}
            </td>
            <td className='col-1'>
                {formattedTime}
            </td>
            <td className='col-3 text-break'>
                {item?.recipient}
            </td>
            <td className='col-4'>
                {item?.subject}
            </td>
            <td className='col-1 text-center'>
                <span className={`badge ${item?.status === 'sent' ? 'badge-success' : 'badge-danger'}`} style={{ textTransform: 'capitalize' }}>
                    {item?.status}
                </span>
            </td>
            <td className='col-1 text-center'>
                <button 
                    className="btn btn-sm btn-outline-primary py-1 px-3 font-weight-bold"
                    style={{ fontSize: '11px', borderRadius: '4px' }}
                    onClick={() => onView(item)}
                >
                    View
                </button>
            </td>
        </tr>
    );
};

export default NotificationLogsTable;
